import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "absolute z-[999] bg-white bottom-1 right-5 w-96 shadow-lg rounded-tr-lg rounded-tl-lg"
};
const _hoisted_2 = { class: "bg-gray-900 h-14 flex justify-between items-center px-3 rounded-tr-lg rounded-tl-lg" };
const _hoisted_3 = { class: "flex items-center w-14 justify-between" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = {
    key: 0,
    class: "py-2 h-52 scrollable-dialog"
};
import { ChevronDownIcon, ChevronUpIcon, XCloseIcon, } from '@gohighlevel/ghl-icons/24/outline';
import { UITextSmMedium } from '@gohighlevel/ghl-ui';
import { ref } from 'vue';
import { useStore } from '../store';
import ProcessingQueueItem from './ProcessingQueueItem.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FileProcessingPopup',
    setup(__props) {
        const state = useStore();
        const collapseContent = ref(false);
        function closeUploadIndicator() {
            state.resetProcessingQueue();
        }
        function toggleCollapseContent() {
            collapseContent.value = !collapseContent.value;
        }
        return (_ctx, _cache) => {
            return (_unref(state).processingQueue.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(_unref(UITextSmMedium), { class: "text-white" }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t(`common.${_unref(state).processingType}`)) + " " + _toDisplayString(_unref(state).processingQueue.length) + " " + _toDisplayString(_ctx.$t('common.items')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", {
                                class: "cursor-pointer",
                                onClick: toggleCollapseContent
                            }, [
                                (collapseContent.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        _createVNode(_unref(ChevronUpIcon), { class: "w-5 h-5 stroke-white" })
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        _createVNode(_unref(ChevronDownIcon), { class: "w-5 h-5 stroke-white" })
                                    ]))
                            ]),
                            _createElementVNode("div", {
                                class: "cursor-pointer",
                                onClick: closeUploadIndicator
                            }, [
                                _createVNode(_unref(XCloseIcon), { class: "w-5 h-5 stroke-white" })
                            ])
                        ])
                    ]),
                    (!collapseContent.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).processingQueue, (file, index) => {
                                return (_openBlock(), _createBlock(ProcessingQueueItem, {
                                    key: index,
                                    file: file
                                }, null, 8 /* PROPS */, ["file"]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]))
                        : _createCommentVNode("v-if", true)
                ]))
                : _createCommentVNode("v-if", true);
        };
    }
});
